import {inject, IReactComponent} from 'mobx-react';
import {VJHistoryFilter} from './VJHistoryFilter';

import './styles.scss';

const mapStoresToProps = (stores: Record<string, any>) => {
    const localizationService = stores.inviteStore?.localizationService;
    return {
        ctrl: stores.inviteStore?.vjHistoryFilterController,
        translate: localizationService?.translate.bind(localizationService)
    };
};

const VJHistoryFilterComponent = inject(mapStoresToProps)(VJHistoryFilter) as IReactComponent;

export default VJHistoryFilterComponent;
